<div class="table-responsive">
    <table class="table table-borderless" cellspacing="3">
        <thead>
            <tr class="smp-table-header">
                <th scope="col" colspan="2" style="min-width: 200px;">{{ 'detailed_processing.lawyer.title.payment.type' | translate }}</th>
                <th scope="col">{{ 'detailed_processing.lawyer.title.payment.receiver' | translate }}</th>
                <th scope="col" width="100">{{ 'detailed_processing.lawyer.title.payment.amount' | translate }}</th>
                <th scope="col" width="100">{{ 'detailed_processing.lawyer.title.payment.received' | translate }}</th>
                <th scope="col" width="60">%</th>
                <th scope="col" width="100">{{ 'detailed_processing.lawyer.title.payment.outstanding' | translate }}</th>
                <th scope="col" width="100">{{ 'detailed_processing.lawyer.title.payment.paid' | translate }}</th>
                <th scope="col" width="100">{{ 'detailed_processing.lawyer.title.payment.open_payments' | translate }}</th>
                <th scope="col" width="180">{{ 'detailed_processing.lawyer.title.payment.booking_date' | translate }}</th>
                <th scope="col" width="180">{{ 'detailed_processing.lawyer.title.payment.payment_target' | translate }}</th>
                <th *ngIf="isEditable()" scope="col" width="60">&nbsp;</th>
            </tr>
        </thead>
        <tbody>
              
            <ng-template [ngIf]="isEditable()" *ngFor="let payment of paymentList?.items; let idx = index">
                <tr case-lawyer-payment-line-editable
                    class="case-lawyer-payment-line"
                    [idPrefix]="(idPrefix + 'payment_' + idx + '.')"
                    [caseId]="caseId"
                    [bananaBox]="payment"
                    [paymentTypes]="paymentTypes"
                    [paymentReceivers]="paymentReceivers"
                    (delete)="removePayment($event)">
                </tr>
            </ng-template>

            <ng-template [ngIf]="!isEditable()" *ngFor="let payment of paymentList?.items; let idx = index">
                <tr case-lawyer-payment-line-readonly
                    [idPrefix]="(idPrefix + 'payment_' + idx + '.')"
                    [caseId]="caseId"
                    [bananaBox]="payment"
                    [paymentTypes]="paymentTypes">
                </tr>
                <tr>
                    <td colspan="11" style="border-bottom: 1px solid black;"></td>
                </tr>
            </ng-template>
        </tbody>
    </table>

    <div class="full-width div-add-payment iq-link-style" *ngIf="isEditable()">
        <a id="{{idPrefix}}btn.create_payment"
           class="btn-add-payment"
           mat-stroked-button
           color="accent"
           (click)="createPayment()">
            {{ 'detailed_processing.lawyer.label.add_payment' | translate | uppercase }}
        </a>
    </div>
</div>
